import { FEATURE_FLAGS } from './constants';

export const defaultFlags = { [FEATURE_FLAGS.LEGACY_PAGE_MIGRATION]: false };
